// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"CampsEdit_pageHeader__4bGcc CampsList_pageHeader__xfjHS","editSection":"CampsEdit_editSection__1hI3v","archiveText":"CampsEdit_archiveText__uOsF2"};